/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- TRIVIA & POLLS DIVISION : STYLES --------------- ++++++++++ */
export default theme => ({
    triviapolls: {

    }
});
